import React from 'react';
import { Tabs, Typography, Button } from 'antd';
import {
    RobotOutlined,
    UserOutlined,
    ArrowLeftOutlined,
    ApartmentOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import CreateSubjectiveProgram from './CreateSubjectiveProgram';
import CreateObjectiveProgram from './CreateObjectiveProgram';
import CreateTrainerLedProgram from './CreateTrainerLedProgram';
import CreateAINestedProgram from './CreateAINestedProgram';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const CreateProgramTabs: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // Determine active tab from URL or default to subjective
    const params = new URLSearchParams(location.search);
    const mode = params.get('mode') || 'subjective';

    const handleTabChange = (key: string) => {
        navigate(`/admin/create?mode=${key}`, { replace: true });
    };

    return (
        <div style={{ padding: '24px' }}>
             <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button 
                        icon={<ArrowLeftOutlined />} 
                        onClick={() => navigate('/admin')}
                        style={{ marginRight: '16px' }}
                    />
                    <div>
                        <Title level={2} style={{ margin: 0 }}>Create New Program</Title>
                        <Text type="secondary">Choose the assessment methodology for your training</Text>
                    </div>
                </div>
            </div>

            <Tabs 
                activeKey={mode} 
                onChange={handleTabChange}
                type="card"
                size="large"
                style={{ marginBottom: '32px' }}
                items={[
                    {
                        key: 'subjective',
                        label: (
                            <span>
                                <RobotOutlined />
                                AI Led (Subjective)
                            </span>
                        ),
                        children: <CreateSubjectiveProgram />
                    },
                    {
                        key: 'ai-nested',
                        label: (
                            <span>
                                <ApartmentOutlined />
                                AI Led (Nested)
                            </span>
                        ),
                        children: <CreateAINestedProgram />
                    },
                    {
                        key: 'trainer-led',
                        label: (
                            <span>
                                <UserOutlined />
                                Trainer Led (Manual)
                            </span>
                        ),
                        children: <CreateTrainerLedProgram />
                    }
                ]}
            />
        </div>
    );
};

export default CreateProgramTabs;
